import * as React from "react";
import {TextField, SelectField} from "web-com";
import {INPUT_TYPE, COLOR, StyleType} from "utils/variables";
import {FIELD_NAMES} from "profile/enums";
import {Card} from "web-com";
import {ILoanProfile} from "IncompleteInfoV2/LoanRequest/utils";

interface IOptions {
    name: string;
    value: string;
}

interface IProps {
    profile: ILoanProfile;
    onChange: (fieldName: string, value: string) => void;
    errors: {[key: string]: string};
}

const selectFieldOptions: IOptions[] = [
    {name: "Select", value: ""},
    {name: "Rental Deposit", value: "Rental Deposit"},
    {name: "Medical", value: "Medical"},
    {name: "Electronics", value: "Electronics"},
    {name: "Marriage", value: "Marriage"},
    {name: "Repay Old Loan", value: "Repay Old Loan"},
    {name: "Education", value: "Education"},
    {name: "Vehicle Purchase", value: "Vehicle Purchase"},
    {name: "New Business", value: "New Business"},
    {name: "Other", value: "Other"},
];

export const LoanDetails = (props: IProps) => {
    const handleChange = (fieldName: string, value: string) => {
        props.onChange(fieldName, value);
    };

    return (
        <Card headerTitle="Loan Details"
            headerBackgroundColor={COLOR.GRAY_BG}
            headerTextColor={COLOR.BLACK}
        >
            <TextField
                type={INPUT_TYPE.NUMBER}
                label="Loan Amount"
                placeholder="Please enter loan amount"
                value={props.profile[FIELD_NAMES.AMOUNT]}
                fieldName={FIELD_NAMES.AMOUNT}
                onChange={handleChange}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
                errorMsg={props.errors[FIELD_NAMES.AMOUNT] || null}
            />
            <TextField
                type={INPUT_TYPE.NUMBER}
                label="Loan Tenure"
                placeholder="Please enter loan tenure"
                value={props.profile[FIELD_NAMES.TENURE]}
                fieldName={FIELD_NAMES.TENURE}
                onChange={handleChange}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
                errorMsg={props.errors[FIELD_NAMES.TENURE] || null}
            />
            <SelectField
                name="Purpose"
                options={selectFieldOptions}
                value={props.profile[FIELD_NAMES.PURPOSE] || undefined}
                fieldName={FIELD_NAMES.PURPOSE}
                onChangeHandler={handleChange}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
                errorMsg={props.errors[FIELD_NAMES.PURPOSE] || null}
            />
        </Card>
    );
};

export default LoanDetails;
